import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/pages/LoginPage'
import Home from '@/components/pages/HomePage'
import Friends from '@/components/pages/FriendsPage'
import Score from '@/components/pages/ScorePage'
import test from '@/components/PtkTest'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Score',
      component: Score
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/friends',
      name: 'Friends',
      component: Friends
    },
    {
      path: '/score',
      name: 'Score',
      component: Score
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js